// CalculateBand cell — full-width button per the MVP CalculateBand pattern.
// Status text (dirty / last calc / error) lives in a separate StatusCell
// band-row below; this cell is just the button.
//
// Chrome: dark-navy background (gray[9]) with white text and the
// production widget border colour (#026aa2). Diletta's default
// `variant="contained"` paints bright cyan (primary.main #1FD9EE)
// which reads as "white" inside the dense dark grid. Dark-on-dark
// with white text matches the rest of the Diletta panel chrome.
import { FC, useContext } from 'react';
import { Button, CircularProgress } from '@mui/material';

import { gray } from '../../../../theme/colors';
import { PricingContext } from '../../../../providers/exotics-pricing-provider';

import './exotics-calculate-band-styles.scss';

interface Props {
  instrumentId: string;
}

const ExoticsCalculateBandContent: FC<Props> = ({ instrumentId }) => {
  const { calculate, loading } = useContext(PricingContext);
  const isLoading = !!loading[instrumentId];

  return (
    <Button
      fullWidth
      variant="contained"
      size="small"
      disabled={isLoading}
      onClick={() => calculate(instrumentId, { withLadder: true })}
      startIcon={isLoading ? <CircularProgress size={12} color="inherit" /> : null}
      sx={{
        fontSize: 11,
        letterSpacing: '0.08em',
        textTransform: 'uppercase',
        py: 0.5,
        // Dark cyan-navy fill anchored against the production widget
        // border colour (#026aa2) which becomes the visible 1px stroke.
        // Sits noticeably darker than the surrounding panel tint so the
        // Calculate row reads as its own band.
        backgroundColor: '#003649',
        color: '#ffffff',
        border: '1px solid #026aa2',
        boxShadow: 'none',
        '&:hover': {
          backgroundColor: '#0a4960',
          borderColor: '#0083AF',
          boxShadow: 'none',
        },
        '&:disabled': {
          backgroundColor: gray[8],
          color: 'rgba(255, 255, 255, 0.5)',
          borderColor: gray[7],
        },
      }}
    >
      {isLoading ? 'Calculating' : 'Calculate'}
    </Button>
  );
};

export default ExoticsCalculateBandContent;
